<template>
    <div>
        <LabeledControl label="What is your flat rate?">
            <CurrencyInput :value="value" @input="$emit('input', $event)"/>
        </LabeledControl>

        <div class="legal pt2">The flat rate for your delivery service applies for both delivery and pick-up, within your city limits. Renters who are outside the city limits will need to pick-up and return themselves.</div>
    </div>
</template>

<script>
import LabeledControl from '@/components/controls/LabeledControl.vue';
import CurrencyInput from '@/components/controls/CurrencyInput.vue';

export default {
    components: {
        LabeledControl,
        CurrencyInput
    },
    props: {
        value: {
            type: Number
        }
    }
};
</script>
